import React from "react";
import { useTranslation } from "react-i18next";
////// Mui
import { styled } from "@mui/material/styles";
import { LinearProgress, Typography } from "@mui/material";
////// Controls & Components
import FileHeader from "./FileHeader";

const LinearProgressStyled = styled(LinearProgress)(({ theme }) => ({
  "& .MuiLinearProgress-bar": {
    borderRadius: 5,
    backgroundColor: theme.palette.error.main,
  },
}));

const UploadError = ({
  file,
  onDelete,
  errors,
  acceptedFileTypes,
  maxFileSize,
}) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <FileHeader file={file} onDelete={onDelete}></FileHeader>
      <LinearProgressStyled variant='determinate' value={100} />
      {errors.map((error, i) => {
        if (error.code === "file-too-large") {
          return (
            <div key={i}>
              <Typography
                style={{ color: "red", padding: 5, margin: 0, fontSize: 14 }}
              >
                {t("toast.file_too_large") + (maxFileSize / (1024 * 1024)) + " MB"}
              </Typography>
            </div>
          );
        }
        if (error.code === "file-invalid-type") {
          return (
            <div key={i + 100}>
              <Typography
                style={{ color: "red", padding: 5, margin: 0, fontSize: 14 }}
              >
                {t("toast.file_types_accepted") + acceptedFileTypes}
              </Typography>
            </div>
          );
        }
        return null;
      })}
    </React.Fragment>
  );
};

export default UploadError;
